// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage .homeWhy {
  padding: clamp(3.5rem, 8vw, 6rem) 0;
  background: radial-gradient(ellipse 70% 50% at 50% 0%, rgba(63, 185, 234, 0.1), transparent 60%), #f4f7fb;
}
.homePage .homeWhy__inner {
  width: min(1120px, 100% - 2.5rem);
  margin-inline: auto;
  width: min(1120px, 100%);
}
.homePage .homeWhy__intro {
  text-align: center;
  max-width: 42rem;
  margin: 0 auto 2.5rem;
}
.homePage .homeWhy__intro h2 {
  margin: 0 0 0.85rem;
  font-size: clamp(1.7rem, 3vw, 2.3rem);
  font-weight: 700;
}
.homePage .homeWhy__intro p {
  margin: 0;
  color: #5c6578;
  font-size: 1.05rem;
  line-height: 1.65;
}
.homePage .homeWhy__item {
  height: 100%;
  padding: 1.5rem 1.35rem;
  background: #ffffff;
  border: 1px solid rgba(26, 31, 44, 0.08);
  border-radius: 20px;
  transition: border-color 0.25s ease, transform 0.25s ease;
}
.homePage .homeWhy__item:hover {
  border-color: rgba(63, 185, 234, 0.45);
  transform: translateY(-3px);
}
.homePage .homeWhy__item h3 {
  margin: 0.85rem 0 0.4rem;
  font-size: 1.15rem;
  font-weight: 600;
}
.homePage .homeWhy__item p {
  margin: 0;
  color: #5c6578;
  font-size: 0.95rem;
  line-height: 1.55;
}
.homePage .homeWhy__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(63, 185, 234, 0.14);
  color: #1a9fd4;
  font-size: 1.15rem;
}
.homePage .homeWhy__cta {
  display: flex;
  justify-content: center;
  margin-top: 2.25rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/Why/Style.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,mCAAA;EACA,yGACE;AAgBJ;AAbE;EDIA,iCAAA;EACA,mBAAA;ECHE,wBAAA;AAgBJ;AAbE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAeJ;AAbI;EACE,mBAAA;EACA,qCAAA;EACA,gBAAA;AAeN;AAZI;EACE,SAAA;EACA,cDzBO;EC0BP,kBAAA;EACA,iBAAA;AAcN;AAVE;EACE,YAAA;EACA,uBAAA;EACA,mBD/BS;ECgCT,wCAAA;EACA,mBAAA;EACA,yDAAA;AAYJ;AAVI;EACE,sCAAA;EACA,2BAAA;AAYN;AATI;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;AAWN;AARI;EACE,SAAA;EACA,cDpDO;ECqDP,kBAAA;EACA,iBAAA;AAUN;AANE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cD7Da;EC8Db,kBAAA;AAQJ;AALE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAOJ","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"../home-tokens.scss\";\r\n\r\n.homePage .homeWhy {\r\n  padding: clamp(3.5rem, 8vw, 6rem) 0;\r\n  background:\r\n    radial-gradient(ellipse 70% 50% at 50% 0%, rgba(63, 185, 234, 0.1), transparent 60%),\r\n    $home-mist;\r\n\r\n  &__inner {\r\n    @include home-container;\r\n    width: min(1120px, 100%);\r\n  }\r\n\r\n  &__intro {\r\n    text-align: center;\r\n    max-width: 42rem;\r\n    margin: 0 auto 2.5rem;\r\n\r\n    h2 {\r\n      margin: 0 0 0.85rem;\r\n      font-size: clamp(1.7rem, 3vw, 2.3rem);\r\n      font-weight: 700;\r\n    }\r\n\r\n    p {\r\n      margin: 0;\r\n      color: $home-muted;\r\n      font-size: 1.05rem;\r\n      line-height: 1.65;\r\n    }\r\n  }\r\n\r\n  &__item {\r\n    height: 100%;\r\n    padding: 1.5rem 1.35rem;\r\n    background: $home-paper;\r\n    border: 1px solid $home-line;\r\n    border-radius: 20px;\r\n    transition: border-color 0.25s ease, transform 0.25s ease;\r\n\r\n    &:hover {\r\n      border-color: rgba(63, 185, 234, 0.45);\r\n      transform: translateY(-3px);\r\n    }\r\n\r\n    h3 {\r\n      margin: 0.85rem 0 0.4rem;\r\n      font-size: 1.15rem;\r\n      font-weight: 600;\r\n    }\r\n\r\n    p {\r\n      margin: 0;\r\n      color: $home-muted;\r\n      font-size: 0.95rem;\r\n      line-height: 1.55;\r\n    }\r\n  }\r\n\r\n  &__icon {\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 14px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(63, 185, 234, 0.14);\r\n    color: $home-teal-deep;\r\n    font-size: 1.15rem;\r\n  }\r\n\r\n  &__cta {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 2.25rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
